module.exports = __webpack_public_path__ + "img/second-day-3.f13ca675.png";